import { ThemePreset } from 'themes/theme-presets';

export const environment = {
    production: false,
    apiUrl: 'https://atr-test.pinsoft.ist/admin/api/v1/management',
    mainDashboard: 'https://atr-test.pinsoft.ist/admin',
    companyName: 'Atr Touristik',
    logo: 'assets/images/atr-logo.png',
    sideMenuLogo: 'assets/images/atr-logo.png',
    email: 'info@atrtouristik.com',
    address: 'A.T.R. Touristik Service GmbH Ziegelstrasse 8 DE 63065 Offenbach',
    theme: ThemePreset,
    bigImageUrl: 'https://s3.pinsoft.ist/atrtest/triptime/cms/Dynamic/Big/',
    smallImageUrl: 'https://s3.pinsoft.ist/atrtest/triptime/cms/Dynamic/Small/',
    showDiscountCoupon: false,
    showLandingPage: false,
    usertour: false,
    usertourToken: '',
    showReports: false,
    showParameters: false
};
